import React, { useState } from 'react';
import { Send, CheckCircle } from 'lucide-react';
import { SITE_CONFIG } from '../utils/constants';

const Franchise = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    city: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const text = `Franchise Enquiry from ${formData.name}. Location: ${formData.city}. Phone: ${formData.phone}`;
    const url = `https://wa.me/${SITE_CONFIG.whatsappNumber}?text=${encodeURIComponent(text)}`;
    window.open(url, '_blank');
  };

  return (
    <div className="page-wrapper">
      <div className="page-header">
        <div className="container text-center">
          <h1 className="page-title">Franchise Opportunities</h1>
          <p className="page-subtitle">Join our growing family and start your own success story.</p>
        </div>
      </div>

      <div className="container section">
        <div className="grid grid-cols-2 mobile-stack gap-12">
          <div className="franchise-content">
            <h2 className="section-title">Why Partner With Little Star?</h2>
            <p className="section-desc">
              We offer a proven business model with high returns and comprehensive support.
              As a franchise partner, you get access to our world-class curriculum,
              marketing support, and operational guidance.
            </p>
            <ul className="benefit-list">
              <li><CheckCircle size={20} className="text-success" /> Low Investment, High ROI</li>
              <li><CheckCircle size={20} className="text-success" /> 360° Marketing Support</li>
              <li><CheckCircle size={20} className="text-success" /> Complete Staff Training</li>
              <li><CheckCircle size={20} className="text-success" /> Academic Support</li>
            </ul>
          </div>

          <div className="contact-form-wrapper">
            <h3 className="form-title">Franchise Enquiry</h3>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="block mb-2 font-semibold">Full Name</label>
                <input type="text" name="name" placeholder="Enter your full name" className="form-input" required onChange={handleChange} />
              </div>
              <div className="form-group">
                <label className="block mb-2 font-semibold">Email Address</label>
                <input type="email" name="email" placeholder="Enter your email" className="form-input" onChange={handleChange} />
              </div>
              <div className="form-group">
                <label className="block mb-2 font-semibold">Phone Number</label>
                <input type="tel" name="phone" placeholder="Enter your phone number" className="form-input" required onChange={handleChange} />
              </div>
              <div className="form-group">
                <label className="block mb-2 font-semibold">City / Location</label>
                <input type="text" name="city" placeholder="Target city or location" className="form-input" required onChange={handleChange} />
              </div>
              {/* <div className="form-group">
                <label className="block mb-2 font-semibold">Investment Budget</label>
                <input type="text" name="budget" placeholder="Approximate budget" className="form-input" onChange={handleChange} />
              </div> */}
              <button type="submit" className="btn btn-primary w-full">Submit Interest</button>
            </form>
          </div>
        </div>
      </div>

      <style>{`
        .page-header { background-color: var(--color-secondary-dark); }
        .mobile-stack { align-items: start; }
        
        .benefit-list {
          margin-top: 2rem;
        }

        .benefit-list li {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 1rem;
          font-weight: 600;
          font-size: 1.1rem;
        }
        
        .space-y-4 > * + * {
           margin-top: 1rem;
        }

        .contact-form-wrapper {
          background: white;
          padding: 3rem;
          border-radius: 2rem;
          box-shadow: var(--shadow-xl);
          border: 1px solid #f1f5f9;
        }

        .form-title {
          font-size: 1.75rem;
          font-weight: 700;
          margin-bottom: 2rem;
          text-align: center;
        }

        .form-group {
          margin-bottom: 1.5rem;
        }

        .form-input {
          width: 100%;
          padding: 0.875rem;
          border-radius: 0.75rem;
          border: 2px solid #e2e8f0;
          font-family: var(--font-body);
          transition: border-color 0.2s;
        }
        
        .form-input:focus {
          outline: none;
          border-color: var(--color-primary);
        }

        @media (max-width: 960px) {
           .mobile-stack { grid-template-columns: 1fr; }
        }
`}</style>
    </div>
  );
};

export default Franchise;
